<script>

import NavBar from "@/components/NavBar";
import FooterBar from "@/components/FooterBar";

export default {
  components: {
    NavBar,
    FooterBar
  }
}

</script>

<template>
  <div>
    <nav-bar />

    <section class="main-content  is-fullheight">
			
          <router-view/>
        
		</section>

    <footer-bar />

  </div>

</template>